import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '18',
  height: '18',
  viewBox: '-1 -1 20 20'
}, [
  h('path', {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    fill: '#0EB87F',
    d: 'M9 1.5C4.9 1.5 1.5 4.9 1.5 9s3.4 7.5 7.5 7.5 7.5-3.4 7.5-7.5S13.1 1.5 9 1.5zM7.5 12.8L3.8 9l1.1-1.1 2.7 2.7 5.7-5.7.9 1.1-6.7 6.8z'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/checkmark-alt.es6.js